import { supabase } from "./supabase";

export async function getRemoteMenu() {
    const { data, error } = await supabase
        .from("menu_documents")
        .select("content, updated_at")
        .eq("id", 1)
        .single();

    if (error) {
        throw error;
    }

    return {
        content: Array.isArray(data?.content) ? data.content : [],
        updatedAt: data?.updated_at || null,
    };
}

export async function saveRemoteMenu(content, userId) {
    const { data, error } = await supabase
        .from("menu_documents")
        .update({
            content,
            updated_at: new Date().toISOString(),
            updated_by: userId,
        })
        .eq("id", 1)
        .select("updated_at")
        .single();

    if (error) {
        throw error;
    }

    return data;
}

export async function isMenuAdmin() {
    const { data, error } = await supabase.rpc("is_menu_admin");

    if (error) {
        throw error;
    }

    return data === true;
}

